import React, { useState, memo } from 'react';
import classnames from 'classnames';
import styles from '../styles.module.css';

function CommonBtn({
  type = 'button',
  value,
  onClick,
  stylesBtn = {},
  classNameStyle = '',
  disabled = false,
  passIcon = '',
  id = '',
  buttonContainerClass = '',
  buttonParentClass = ''
}) {
  const { btn } = styles;

  return (
    <div className={buttonContainerClass}>
      <div className={buttonParentClass}>
        <button
          disabled={disabled}
          type={type}
          onClick={onClick}
          style={stylesBtn}
          id={id}
          className={`${btn} flex items-center mr-1 sm:mr-3  border border-green-600
           text-green-600 py-1 px-1 sm:px-2 font-roboto 
          text-xs  md:text-sm font-normal rounded ${classNameStyle}`}
        >
          {passIcon && <img src={passIcon} alt="" className="pr-3" />}

          {value}
        </button>
      </div>
    </div>
  );
}

export default memo(CommonBtn);
